import React, { useEffect, useState, useContext } from "react";
import { message, Progress, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";

import { DateFormat, fetchApi, getApi, saveApi } from "../../../helpers";
import Badge from "../../../components/Badge";
import CardContainer from "../../../components/Card";
import TableContainer from "../../../components/Table";
import ProductPopup from "./Popup";
import ProductSidebar from "./Sidebar";
import Popup from "../../../components/Popup";
import { StoreContext } from "../../../context";
import { canWrite } from "../../../helpers/permissions";

const allColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    // sorter: true,
  },
  {
    title: "Sub Category",
    dataIndex: "sub_category_name",
    key: "sub_category_name",
  },
  {
    title: "Group",
    dataIndex: "sub_category_group_name",
    key: "sub_category_group_name",
  },
  {
    title: "Quantity",
    dataIndex: "total_stock",
    key: "total_stock",
    align: "center",
    sorter: true,
    render: (text) => <div style={{ textAlign: "right" }}>{text}</div>,
  },
  // {
  //   title: "Price Range",
  //   dataIndex: "price",
  //   key: "price",
  //   render: (text) => <div style={{ textAlign: "right" }}>₹ {text}</div>,
  //   sorter: true,
  // },
  {
    title: "Date",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    sorter: true,
    render: (text) => DateFormat(text),
  },
  {
    title: "Status",
    dataIndex: "total_stock",
    key: "total_status",
    align: "center",
    sorter: true,
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    align: "center",
    sorter: true,
    render: (text) => <Badge active={text} />,
  },
];

const mainColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
  },
  {
    title: "Sub Category",
    dataIndex: "sub_category_name",
    key: "sub_category_name",
  },
  {
    title: "Group",
    dataIndex: "sub_category_group_name",
    key: "sub_category_group_name",
  },
  {
    title: "Date",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    sorter: true,
    render: (text) => DateFormat(text),
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    align: "center",
    sorter: true,
    render: (text) => <Badge active={text} />,
  },
];

const allHeaders = [
  "CATEGORY",
  "SUBCATEGORY",
  "GROUP",
  "PRODUCT NAME",
  "PRODUCT DESCRIPTION",
  "VARIANT NAME",
  "WEIGHT",
  "COST PRICE",
  "MRP",
  "DISCOUNTED PRICE",
  "STOCK",
  "SKU",
  "ID",
  "STOREID"
];

const mainHeaders = [
  "CATEGORY",
  "SUBCATEGORY",
  "GROUP",
  "PRODUCT NAME",
  "PRODUCT DESCRIPTION",
  "VARIANT NAME",
  "WEIGHT",
  "SKU"
];

// product -> product_id,name,sku,description,created_at,stock,price,product_status,category,category_id,sub_category_name,sub_category_id,meta.weight
export default function Product({ stores }) {
  const { storeId } = useContext(StoreContext);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState(mainColumns)
  const [config, setConfig] = useState({});
  const [savedPayload, setSavedPayload] = useState({});
  const [total, setTotal] = useState(8);
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState({});
  const [sidebar, setSidebar] = useState(false);
  const [popup, setPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [storeOptions, setStoreOptions] = useState([])
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [searchedCategory, setSearchedCategory] = useState(false);
  const [importPopup, setImportPopup] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [importUrl, setImportUrl] = useState("");

  const [bulkUpdatePopup, setBulkUpdatePopup] = useState(false);
  const [xlsFile, setXlsFile] = useState(null);
  const [bulkUpdating, setBulkUpdating] = useState(false);
  const [bulkProgress, setBulkProgress] = useState(0);
  const [bulkUpdateUrl, setBulkUpdateUrl] = useState("");
  const [selectedStoreForBulkUpdate, setSelectedStoreForBulkUpdate] = useState(storeId || ""); // New state for store selection

  useEffect(() => {
    getStores();
    // Load categories on component mount
    getCategoryOptions();
  }, []);
  
  useEffect(() => {
    getConfig();
  }, [storeId]);

  const getStores = async () => {
    const res = await getApi({}, "getStores", "dashboard/");
    if (res.data && res.data.length) setStoreOptions(res.data);
  };

  const getConfig = async () => {
    if (storeId) {
      if (!config.in_stock || columns === mainColumns) {
        setLoading(true)
        const res = await fetchApi();
        if (res.in_stock) {
          let updatedColumns = allColumns.map((c) => {
            if (c.key === "total_status") {
              c = {
                ...c, render: (text) => {
                  let label = "out of stock";
                  if (text >= res.finishing_soon && text < res.in_stock) {
                    label = "finishing soon";
                  } else if (text >= res.finishing_soon && text < res.plenty) {
                    label = "in stock";
                  } else if (text >= res.plenty) {
                    label = "plenty";
                  }
                  return <Badge productStatus={label} />;
                },
              };
            }
            return c;
          });
          setColumns(updatedColumns)
          setConfig(res);
          getList(savedPayload);
        }
      } else getList(savedPayload)
    } else {
      setColumns(mainColumns)
      getList(savedPayload)
    }
  };

  const getList = async (payload = {}) => {
    setLoading(true);
    if (payload.from !== undefined || payload.to !== undefined) {
      delete payload.from;
      delete payload.to;
    }
    if (payload.filter && storeId) {
      let productStatus = payload.filter;
      if (productStatus === "p" || productStatus === "plenty") {
        payload = { ...payload, filter: "plenty" };
        payload = { ...payload, from: config.plenty };
      } else if (productStatus === "i" || productStatus === "in stock") {
        payload = { ...payload, filter: "in stock" };
        payload = { ...payload, from: config.in_stock, to: config.plenty - 1 };
      } else if (
        productStatus === "f" ||
        productStatus === "finishing soon"
      ) {
        payload = { ...payload, filter: "finishing soon" };
        payload = {
          ...payload,
          from: config.finishing_soon,
          to: config.in_stock - 1,
        };
      } else {
        payload = { ...payload, filter: "out of stock" };
        payload = { ...payload, from: 0, to: config.finishing_soon - 1 };
      }
    }
    if (storeId) payload = { ...payload, store_id: storeId }
    else delete payload.store_id;
    const res = await getApi(payload, "getProducts");
    if (res.data) {
      setList(res.data);
      setTotal(res.meta?.total);
    }
    setSavedPayload(payload);
    setLoading(false);
  };

  const getCategoryOptions = async (keyword = '') => {
    const res = await getApi(
      { page: 0, size: 100, keyword: keyword, type: "admin" },
      "getCategory"
    );
    if (res.data) {
      setCategoryOptions(res.data);
      setSearchedCategory(true);
    }
  };

  const saveHandler = async (values) => {
    setSidebar(false);
    setPopup(false);
    setLoading(true);
    let msg = "Added Product";
    let apiName = "createProduct";
    if (selected.product_id) {
      apiName = "updateProduct";
      msg = "Updated Product";
      values = { ...values, product_id: selected.product_id };
    }
    const res = await saveApi(values, msg, apiName);
    if (res) {
      getList(savedPayload);
    } else {
      setLoading(false);
    }
  };

  const uploadCsvFile = ({ file }) => {
    let result = false;
    const reader = new FileReader();
    reader.onload = async (e) => {
      var csv = e.target.result;
      var lines = csv.split("\n");
      var headers = lines[0].replaceAll('"', "").split(",");
      if (storeId) result = allHeaders.every((v) => headers.includes(v));
      else result = mainHeaders.every((v) => headers.includes(v));
      if (result) {
        setProgress(10);
        setTimeout(() => setProgress(50), 1000);
        setTimeout(() => {
          setProgress(90);
          setCsvFile(file);
        }, 2000);
        const fmData = new FormData();
        const headers = { "content-type": "multipart/form-data" };
        if (storeId) {
          fmData.append("store_inventory", file);
          const res = await getApi(fmData, "uploadStoreinventory", "ecomm/", headers);
          if (res && res.success) setImportUrl(res.data.url)
        } else {
          fmData.append("inventory", file);
          const res = await getApi(fmData, "uploadinventory", "ecomm/", headers);
          if (res && res.success) {
            setImportUrl(res.data.url);
          }
        }
      } else {
        message.warn("Unsupported File! Please check the file and try again.");
      }
    };
    reader.readAsText(file);
  };

  const importProductsHandler = async () => {
    if (importUrl) {
      setImporting(true);
      let res;
      if (storeId) {
        res = await saveApi(
          { store_inventory: importUrl },
          "Stocks Bulk Imported",
          "storeVariants"
        );
      } else {
        res = await saveApi(
          { inventory: importUrl },
          "Products Bulk Imported",
          "bulkInventory"
        );
      }
      if (res) {
        getList(savedPayload);
      }
      setImportPopup(false);
    } else {
      message.warn("Please Upload Csv file first.");
    }
    setCsvFile(null);
    setImporting(false);
  };

  const uploadBulkUpdateFile = ({ file }) => {
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
    ];
    
    if (!allowedTypes.includes(file.type)) {
      message.warn("Please upload only Excel files (.xlsx or .xls)");
      return;
    }

    setBulkProgress(10);
    setTimeout(() => setBulkProgress(50), 1000);
    setTimeout(async () => {
      setBulkProgress(90);
      setXlsFile(file);
      
      // Upload the file to get the URL
      const fmData = new FormData();
      const headers = { "content-type": "multipart/form-data" };
      fmData.append("store_inventory", file);
      
      try {
        const res = await getApi(fmData, "uploadStoreinventory", "ecomm/", headers);
        if (res && res.success) {
          setBulkUpdateUrl(res.data.url);
          setBulkProgress(100);
        } else {
          message.error("Failed to upload file");
          setBulkProgress(0);
        }
      } catch (error) {
        console.error("Error uploading bulk update file:", error);
        message.error("Failed to upload file");
        setBulkProgress(0);
      }
    }, 2000);
  };

  const bulkUpdateHandler = async () => {
    if (!bulkUpdateUrl) {
      message.warn("Please upload Excel file first.");
      return;
    }

    if (!selectedStoreForBulkUpdate) {
      message.warn("Please select a store to perform bulk update.");
      return;
    }

    setBulkUpdating(true);
    
    try {
      const payload = {
        location: bulkUpdateUrl,
        store_id: selectedStoreForBulkUpdate
      };

      const res = await saveApi(
        payload,
        "Bulk Price Update Completed",
        "bulkPriceUpdate"
      );

      if (res) {
        getList(savedPayload);
        setBulkUpdatePopup(false);
      }
    } catch (error) {
      console.error("Error in bulk price update:", error);
      message.error("Failed to perform bulk update");
    }

    setXlsFile(null);
    setBulkUpdateUrl("");
    setBulkProgress(0);
    setBulkUpdating(false);
    setSelectedStoreForBulkUpdate(storeId || ""); // Reset to current store or empty
  };

  // Reset store selection when popup opens
  const openBulkUpdatePopup = () => {
    setSelectedStoreForBulkUpdate(storeId || "");
    setBulkUpdatePopup(true);
  };

  return (
    <>
      {importPopup && (
        <Popup
          visible={true}
          title="Import Products"
          cancelHandler={() => (setCsvFile(null), setImportPopup(false))}
          saveHandler={importProductsHandler}
          saveText="Import"
          width={380}
          loading={importing}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "5px 24px",
              flexDirection: "column",
            }}
          >
            <Upload.Dragger
              accept=".csv"
              listType="picture"
              maxCount={1}
              customRequest={uploadCsvFile}
              onRemove={() => {
                setCsvFile(null);
              }}
              fileList={csvFile ? [csvFile] : []}
            >
              <div style={{ padding: "5px 15px", marginBottom: 10 }}>
                <InboxOutlined size={55} />
                <p>
                  Click or drag <span style={{ color: "green" }}>CSV</span> file
                  to this area to import products
                </p>
              </div>
            </Upload.Dragger>
            {progress > 0 && progress !== 90 ? (
              <Progress percent={progress} />
            ) : null}
          </div>
        </Popup>
      )}
      {bulkUpdatePopup && (
        <Popup
          visible={true}
          title="Bulk Price Update"
          cancelHandler={() => (
            setXlsFile(null), 
            setBulkUpdateUrl(""), 
            setBulkProgress(0), 
            setSelectedStoreForBulkUpdate(storeId || ""),
            setBulkUpdatePopup(false)
          )}
          saveHandler={bulkUpdateHandler}
          saveText="Update Prices"
          width={450}
          loading={bulkUpdating}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "5px 24px",
              flexDirection: "column",
            }}
          >
            {/* Store Selection Dropdown */}
            <div style={{ 
              width: "100%", 
              marginBottom: "20px",
              textAlign: "left"
            }}>
              <label style={{ 
                display: "block", 
                marginBottom: "8px", 
                fontWeight: "500",
                fontSize: "14px"
              }}>
                Select Store <span style={{ color: "red" }}>*</span>
              </label>
              <select
                value={selectedStoreForBulkUpdate}
                onChange={(e) => setSelectedStoreForBulkUpdate(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  fontSize: "14px",
                  backgroundColor: "white",
                  outline: "none"
                }}
              >
                <option value="">Select a store</option>
                {storeOptions.map((store) => (
                  <option key={store.store_id} value={store.store_id}>
                    {store.name}
                  </option>
                ))}
              </select>
            </div>

            {/* File Upload */}
            <Upload.Dragger
              accept=".xlsx,.xls"
              listType="picture"
              maxCount={1}
              customRequest={uploadBulkUpdateFile}
              onRemove={() => {
                setXlsFile(null);
                setBulkUpdateUrl("");
                setBulkProgress(0);
              }}
              fileList={xlsFile ? [xlsFile] : []}
              style={{ width: "100%" }}
            >
              <div style={{ padding: "5px 15px", marginBottom: 10 }}>
                <InboxOutlined size={55} />
                <p>
                  Click or drag <span style={{ color: "blue" }}>Excel</span> file
                  to this area for bulk price update
                </p>
                <p style={{ fontSize: "12px", color: "#666" }}>
                  Supported formats: .xlsx, .xls
                </p>
              </div>
            </Upload.Dragger>
            
            {bulkProgress > 0 && bulkProgress !== 100 ? (
              <Progress percent={bulkProgress} style={{ width: "100%", marginTop: "16px" }} />
            ) : null}
          </div>
        </Popup>
      )}
      {sidebar && (
        <ProductSidebar
          visible={sidebar}
          product_id={selected.product_id}
          onClose={() => setSidebar(false)}
          editProductHandler={() => {
            getCategoryOptions();
            setPopupTitle("Edit Product Details");
            setPopup(true);
          }}
        />
      )}
      {popup && (
        <ProductPopup
          updateProduct={selected.name ? true : false}
          title={popupTitle}
          visible={popup}
          data={selected}
          categoryOptions={categoryOptions}
          storeOptions={storeOptions}
          cancelHandler={() => setPopup(false)}
          saveHandler={saveHandler}
        />
      )}
      <CardContainer bordered={false} hoverable={false}>
        <TableContainer
          breadcrumbTitle="Product Management"
          loading={loading}
          total={total}
          columns={columns}
          data={list}
          dropdownSearchHandler={(v) => getCategoryOptions(v)}
          dropdownFilterOptions={
            categoryOptions.length > 0
              ? categoryOptions.map(
                (category) =>
                (category = {
                  value: category.name,
                  key: category.category_id,
                })
              )
              : [
                {
                  label: searchedCategory
                    ? "No Such Category"
                    : "Type to Search Category",
                  disabled: true,
                },
              ]
          }
          tagFilterOptions={storeId ? [
            { label: "Plenty", value: "plenty" },
            { label: "In Stock", value: "in stock" },
            { label: "Finishing Soon", value: "finishing soon" },
            { label: "Out Of Stock", value: "out of stock" },
          ] : []}
          combineFilters
          addButton={canWrite() && (storeId ? false : true)}
          addHandler={() => {
            getCategoryOptions();
            setSelected({});
            setPopupTitle("Add Product");
            setPopup(true);
          }}
          rowClickHandler={(record) => (setSidebar(true), setSelected(record))}
          functionsHandler={getList}
          parseButton={canWrite() ? "Bulk Update" : null}
          parseHandler={openBulkUpdatePopup}
        ></TableContainer>
      </CardContainer>
    </>
  );
}
